export const SET_SUNBURST_DELETE_2FA = '[SUNBURST] DELETE 2FA FLOW';
export const SET_SUNBURST_UPDATE_PHONE_DETAILS_FLOW = '[SUNBURST] UPDATE PHONE DETAILS FLOW';

const initialState = {
  deleteTwoFAFlow: false,
  updatePhoneDetailsFlow: false,
};

export default function (state = initialState, action) {
  if (action.type === SET_SUNBURST_DELETE_2FA) {
    return { ...state, deleteTwoFAFlow: action.deleteTwoFAFlow };
  }
  if (action.type === SET_SUNBURST_UPDATE_PHONE_DETAILS_FLOW) {
    return { ...state, updatePhoneDetailsFlow: action.updatePhoneDetailsFlow };
  }
  return state;
}
